import React, { lazy, Suspense, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Spin } from 'antd';
import { nativeRequest } from './transport';
import TandemSessionBoundary from '../../features/tandem/TandemSessionBoundary';
import { TandemStatus } from '../../features/tandem/api';
import { beginJoin, bootstrapMetadata, failedJoin } from 'services/monitoring';
const NativeAdmin = lazy(() => import('./Admin'));

/** Admin detail has its own route; resolve ownership before legacy mount effects. */
export default function AdminSessionEngineRoute({
  legacy,
}: {
  legacy: React.ReactNode;
}) {
  const { session_id: id } = useParams<{ session_id: string }>();
  const [result, setResult] = useState<{
    id: string;
    engine?: string;
    error?: string;
    tandem?: TandemStatus | null;
  } | null>(null);
  useEffect(() => {
    beginJoin(Number(id));
    const joinId = bootstrapMetadata(Number(id))?.join_id;
    const controller = new AbortController();
    setResult(null);
    void nativeRequest<{ execution_engine: string; tandem?: TandemStatus }>(
      `/sessions/${id}/execution-context/`,
      undefined,
      controller.signal,
    )
      .then(data => {
        if (!controller.signal.aborted)
          setResult({ id, engine: data?.execution_engine, tandem: data?.tandem });
      })
      .catch(error => {
        if (!controller.signal.aborted) {
          failedJoin(Number(id), joinId);
          setResult({ id, error: String(error) });
        }
      });
    return () => controller.abort();
  }, [id]);
  if (!result || result.id !== id) return <Spin />;
  if (result.error) return <Alert type="error" title={result.error} />;
  if (!['legacy', 'fast'].includes(result.engine || '')) return <Alert type="error" title="Unknown execution engine" />;
  const content = result.engine === 'legacy' ? legacy : <Suspense fallback={<Spin />}><NativeAdmin key={id} sessionId={Number(id)} /></Suspense>;
  return result.tandem ? <TandemSessionBoundary key={id} sessionId={Number(id)} initial={result.tandem}>{content}</TandemSessionBoundary> : <>{content}</>;
}
